import { ChangeDetectionStrategy, Component, HostBinding, Inject, ViewEncapsulation } from "@angular/core";
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from "@angular/material/legacy-dialog";
import { Store } from "@ngrx/store";
import { CORE_ROUTE, CoreState } from "@obg/ngx.core";
import { RouteAction } from "@obg/ngx.router";

import { SmTermsAndConditionsMessageContent } from "./sm-terms-and-conditions-message.model";

@Component({
	selector: "obg-sm-terms-and-conditions-message",
	templateUrl: "./sm-terms-and-conditions-message.container.html",
	styleUrls: ["./sm-terms-and-conditions-message.container.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class SmTermsAndConditionsMessage {
	@HostBinding("class.obg-sm-terms-and-conditions-message") class = true;

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: SmTermsAndConditionsMessageContent | undefined,
		private store: Store<CoreState>
	) {}

	onReadMore() {
		this.store.dispatch(RouteAction.navigate(CORE_ROUTE.termsAndConditions));
	}
}
